import React from 'react';
import { CHILDREN_COMPONENT } from "./core/index.mjs";
function getOriginChildren(Children) {
  if ( /*#__PURE__*/React.isValidElement(Children.origin) && Children.origin.type[CHILDREN_COMPONENT]) {
    return getOriginChildren(Children.origin.type);
  }
  return Children.origin;
}
export default getOriginChildren;
//# sourceMappingURL=getOriginChildren.mjs.map